import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
//import { setCurrentTopic } from "Actions";
import Goto from "../Goto";
import Comments from "../Comments";

//import _ from "i18n";
import { TTP_API_URL, TTP_FORUM_URL } from "Config";
import { slugify } from "Utils";

import {
  //purifyString,
  getDateLabel,
  convertDateFromUTC,
  getUserNameForAvatar
} from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";

class Content extends PureComponent {
  renderTopic() {
    const { currentTopic } = this.props.viewer;

    const {
      title,
      description,
      user,
      language,
      category,
      organization,
      createdAt //,
    } = currentTopic;

    const avatar =
      user && user.avatar ? (
        <span
          style={{
            borderColor: category.colorCode,
            backgroundImage: `url(${
              user.avatarUrl ? user.avatarUrl : TTP_API_URL + "/" + user.avatar
            })`
          }}
        />
      ) : (
        <span className="avatar-by-name">
          {getUserNameForAvatar(user.firstName, user.lastName)}
        </span>
      );

    const nameAttr = `name${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    return (
      <div
        className={classnames(
          styles.topic_container,
          "small-12 medium-9 article-content rmodal__left"
        )}
      >
        <div className={styles.date}>
          {getDateLabel(convertDateFromUTC(createdAt))}
        </div>
        <div className={classnames("grid-x", styles.current)}>
          <div className={classnames("cell small-3", styles.infos)}>
            <div className={styles.avatar}>{avatar}</div>
            <div className={styles.user}>
              <h3>{user.firstName + " " + user.lastName}</h3>
              {!user.function ? null : <span>{user.function}</span>}
            </div>
            <div className={styles.organization}>
              {!organization ? null : (
                <h4>
                  {organization.abbreviation
                    ? organization.abbreviation
                    : organization.name}
                </h4>
              )}
              <span
                className={styles.category}
                style={{ backgroundColor: category.colorCode }}
              >
                {category[nameAttr]}
              </span>
            </div>
          </div>
          <div className={classnames("cell small-9", styles.title)}>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
        </div>
        {/*this.renderComments()*/}

        {/*}<div className="article-file__content">{this.renderTopicContent()}</div>*/}
      </div>
    );
  }

  render() {
    const { viewer, type } = this.props;
    const { currentTopic, topics } = viewer;

    if (!currentTopic || !topics) {
      return null;
    }

    const path = `${TTP_FORUM_URL}/topics/${slugify(currentTopic.title)}/${
      currentTopic.id
    }`;

    return (
      <Fragment>
        <div className="cell rmodal__body grid-x">
          <div
            className={classnames(
              styles.topic_container,
              "article-content rmodal__left"
            )}
          >
            <Goto url={path} />
            <div className={styles.topic}>{this.renderTopic()}</div>
            <Comments currentResource={{ ...currentTopic }} type={type} />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  viewer: state.topicViewer,
  auth: state.auth,
  language: state.params.lng
});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);



// WEBPACK FOOTER //
// ./src/components/Reveal/TopicViewer/Content.js